import { render, staticRenderFns } from "./CreateBillableItem.vue?vue&type=template&id=16126322&scoped=true"
import script from "./CreateBillableItem.vue?vue&type=script&lang=js"
export * from "./CreateBillableItem.vue?vue&type=script&lang=js"
import style0 from "./CreateBillableItem.vue?vue&type=style&index=0&id=16126322&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16126322",
  null
  
)

export default component.exports